import { render, staticRenderFns } from "./CalendarEvent.vue?vue&type=template&id=6307ea64"
import script from "./CalendarEvent.js?vue&type=script&lang=js&external"
export * from "./CalendarEvent.js?vue&type=script&lang=js&external"
import style0 from "./CalendarEvent.vue?vue&type=style&index=0&id=6307ea64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports